import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import e from "../../../../internal/DataOverviewDetails/DataOverviewDetailsSkeleton.js";
import { TransactionDataContent as a } from "./TransactionDataContent.js";
import { boolOrFalse as s } from "../../../../../utils/value/bool.js";
const g = ({ error: n, isFetching: i, transaction: o, extraFields: r }) => s(i) || !(o || n) ? /* @__PURE__ */ t(e, { skeletonRowNumber: 5 }) : o ? /* @__PURE__ */ t(a, { transaction: o, extraFields: r }) : null;
export {
  g as TransactionData
};
